import { NeoModel, ValueObject } from "@singularsystems/neo-core";

export default class DeclineBatchCommand extends ValueObject{
  batchId: number = 0;
}